import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "card p-3",
  style: {"height":"316px"}
}
const _hoisted_2 = { class: "card-body p-3" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div><div class=\"d-flex align-items-center mb-4\"><i class=\"bi bi-search me-2\"></i><input class=\"p-2 border-secondary w-100 border-1 rounded-2 form-control\" placeholder=\"Ingrese el nombre de la ubicación\" type=\"text\"></div><div class=\"d-flex align-items-center my-3\"><div class=\"bg-blue btn-icon col-auto me-3\"><i class=\"bi bi-plus fs-2x text-white\"></i></div> Agregar ubicación </div></div>", 1)
const _hoisted_4 = {
  class: "d-flex flex-wrap my-3 overflow-auto",
  style: {"max-height":"190px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "bg-blue btn-icon col-auto" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt-fill fs-2x text-white" })
], -1)
const _hoisted_6 = { class: "text-center fs-8" }
const _hoisted_7 = { class: "text-muted fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSedes, (sede, e) => {
          return (_openBlock(), _createElementBlock("div", {
            key: e,
            class: "d-flex flex-column align-items-center px-2 w-25"
          }, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(sede.nombre), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}